import React from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, FormGroup, FormControlLabel, Checkbox, Radio } from '@mui/material';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import makeStyles from '@mui/styles/makeStyles';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from 'moment';
import './RecurrenceModal.css'

function RecurrenceModal(props) {
    const useStyles  = makeStyles({
        root: {
          '& label.Mui-focused': {
            color: '#3FA7D6',
          },
          '& .MuiInput-underline:after': {
            borderBottomColor: '#3FA7D6',
          },
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: 'lightblue',
            },
            '&:hover fieldset': {
              borderColor: '#3FA7D6',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#3FA7D6',
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '3FA7D6'
            }
          },
        },
    });

    const classes = useStyles();

    return (
        <Dialog style={{ zIndex: 2000 }} open={props.showModal} onClose={props.handleClose} className="modal-style" disableEnforceFocus>
            <DialogTitle>Custom Recurrence</DialogTitle>
            <DialogContent className="px-4 py-3">
                <div>
                    <div className="d-flex align-items-center justify-content-between mb-4">
                        <span style={{fontSize: "18px"}}>Repeat every</span>
                        <TextField 
                            className={classes.root}
                            id="recur-num"
                            name="num"
                            type="number"
                            InputProps={{ inputProps: { min: "1", max: "30"} }}
                            value={props.num}
                            variant="outlined"
                            onChange={(e) => {props.setNum(parseInt(e.target.value))}}
                            onKeyDown={(e) => {e.preventDefault()}}
                            style={{caretColor: "transparent"}}/>
                        <Autocomplete
                            id="recur-option"
                            name="option"
                            value={props.option}
                            options={["day", "week", "month", "year"]}
                            getOptionLabel={(option) => option}
                            disableClearable
                            onKeyDown={(e) => {e.preventDefault()}}
                            onChange={(e, val) => {props.setOption(val)}}
                            style={{ width: 120, caretColor: "transparent"}}
                            renderInput={(params) => <TextField className={classes.root} {...params} variant="outlined" />}/>
                    </div>
                    {props.option === "week" &&
                        <div id="recur-repeat-on" className="mb-3">
                            <span className="mr-2" style={{fontSize: "18px"}}>Repeat on</span>
                            <FormGroup row>
                                <FormControlLabel control={<Checkbox name="Mon" onChange={props.handleCheckBox} checked={props.days.includes("Mon")} />} label="Monday" />
                                <FormControlLabel control={<Checkbox name="Tue" onChange={props.handleCheckBox} checked={props.days.includes("Tue")} />} label="Tuesday" />
                                <FormControlLabel control={<Checkbox name="Wed" onChange={props.handleCheckBox} checked={props.days.includes("Wed")} />} label="Wednesday" />
                                <FormControlLabel control={<Checkbox name="Thu" onChange={props.handleCheckBox} checked={props.days.includes("Thu")} />} label="Thursday" />
                                <FormControlLabel control={<Checkbox name="Fri" onChange={props.handleCheckBox} checked={props.days.includes("Fri")} />} label="Friday" />
                                <FormControlLabel control={<Checkbox name="Sat" onChange={props.handleCheckBox} checked={props.days.includes("Sat")} />} label="Saturday" />
                                <FormControlLabel control={<Checkbox name="Sun" onChange={props.handleCheckBox} checked={props.days.includes("Sun")} />} label="Sunday" />
                            </FormGroup>
                        </div>
                    }
                    <div>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <div className="mb-2 d-flex align-items-center">Ends</div>
                            <div className="mb-2 d-flex align-items-center">
                                <FormControlLabel
                                    className="on-radio"
                                    control={<Radio 
                                        name="ends" 
                                        id="recur-on" 
                                        checked={!props.disabled}
                                        onChange={() => props.setDisabled(!props.disabled)}
                                    />}
                                    label="On"
                                />
                                <DatePicker
                                    margin="normal"
                                    id="recur-end-date"
                                    format="MM/dd/yyyy"
                                    maxDate={props.project ? new Date(props.project.end_date) : new Date(props.endOnDate)}
                                    value={props.endOnDate ? new Date(props.endOnDate) : null}
                                    onChange={(date) => {props.setEndOnDate(date)}}
                                    disabled={props.disabled}
                                    enableAccessibleFieldDOMStructure={false}
                                    slots={{
                                        textField: TextField
                                    }}
                                    slotProps={{
                                        textField: {
                                            className: classes.root
                                        },
                                        popper: {
                                            style: { zIndex: 2000 },
                                        },
                                    }} />
                            </div>
                            <div className="d-flex align-items-center">
                                <FormControlLabel
                                    className="after-radio"
                                    control={<Radio 
                                        name="ends" 
                                        id="recur-after"
                                        checked={props.disabled}
                                        onChange={() => props.setDisabled(!props.disabled)}
                                    />}
                                    label="After"
                                />
                                <TextField 
                                    className={classes.root + " mr-3"}
                                    id="rec-num-of-repeats"
                                    type="number"
                                    name="num-of-repeats"
                                    InputProps={{ inputProps: { min: "1", max: "30"} }}
                                    value={props.numberOfRepeats}
                                    variant="outlined"
                                    onChange={(e) => {props.setNumberOfRepeats(parseInt(e.target.value))}}
                                    onKeyDown={(e) => {e.preventDefault();}}
                                    style={{caretColor: "transparent"}}
                                    disabled={!props.disabled}/>
                                <span className={!props.disabled ? "text-muted" : ""} style={{fontSize: "18px"}}>Occurences</span>
                            </div>
                        </LocalizationProvider>
                    </div>
                </div>
            </DialogContent>
            <DialogActions style={{borderTop: "0 none", justifyContent: "center"}}>
                <Button 
                    className="w-25 mx-4" 
                    variant="outlined" 
                    onClick={props.handleCancel} 
                    onChange={() => props.setDays(["Monday"])}>
                    Cancel
                </Button>
                <Button className="w-25 mx-4" variant="contained" onClick={props.handleSubmit}>
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RecurrenceModal;
